import React, { useState, useCallback } from 'react'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'

const CropTool = ({ image, onCropComplete }) => {
  const [crop, setCrop] = useState({
    unit: '%',
    x: 5,
    y: 5,
    width: 90,
    height: 90,
    aspect: undefined
  })
  const [completedCrop, setCompletedCrop] = useState(null)
  const [imgRef, setImgRef] = useState(null)
  const [aspectRatio, setAspectRatio] = useState(null)

  const onLoad = useCallback((img) => {
    setImgRef(img)
  }, [])

  const handleCropComplete = useCallback(() => {
    if (!completedCrop || !imgRef) return

    const canvas = document.createElement('canvas')
    const scaleX = imgRef.naturalWidth / imgRef.width
    const scaleY = imgRef.naturalHeight / imgRef.height
    const ctx = canvas.getContext('2d')

    canvas.width = completedCrop.width * scaleX
    canvas.height = completedCrop.height * scaleY

    ctx.drawImage(
      imgRef,
      completedCrop.x * scaleX,
      completedCrop.y * scaleY,
      completedCrop.width * scaleX,
      completedCrop.height * scaleY,
      0,
      0,
      canvas.width,
      canvas.height
    )

    canvas.toBlob((blob) => {
      if (!blob) return
      const reader = new FileReader()
      reader.readAsDataURL(blob)
      reader.onloadend = () => {
        onCropComplete(reader.result)
      }
    })
  }, [completedCrop, imgRef, onCropComplete])

  const aspectRatios = [
    { label: 'Free', value: null },
    { label: '1:1', value: 1 },
    { label: '4:3', value: 4 / 3 },
    { label: '16:9', value: 16 / 9 },
    { label: '3:4', value: 3 / 4 },
    { label: '9:16', value: 9 / 16 }
  ]

  const handleAspectRatioChange = (ratio) => {
    setAspectRatio(ratio)
    setCrop(prev => ({ ...prev, aspect: ratio }))
  }

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-2">
        {aspectRatios.map((ratio) => (
          <button
            key={ratio.label}
            onClick={() => handleAspectRatioChange(ratio.value)}
            className={`px-4 py-2 rounded-lg font-medium transition-colors ${
              aspectRatio === ratio.value
                ? 'bg-blue-600 text-white'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
          >
            {ratio.label}
          </button>
        ))}
      </div>

      <div className="flex justify-center bg-gray-100 rounded-lg p-4">
        <ReactCrop
          crop={crop}
          onChange={(c) => setCrop(c)}
          onComplete={(c) => setCompletedCrop(c)}
        >
          <img
            src={image}
            alt="Crop preview"
            onLoad={(e) => {
              onLoad(e.currentTarget)
            }}
            onError={(e) => {
              if (process.env.NODE_ENV === 'development') console.error('CropTool: Failed to load image', image, e)
            }}
            className="max-h-[700px] max-w-full"
            crossOrigin="anonymous"
          />
        </ReactCrop>
      </div>

      <div className="flex justify-center">
        <button
          onClick={handleCropComplete}
          disabled={!completedCrop}
          className="px-6 py-2 bg-green-600 text-white rounded-lg font-medium hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
        >
          Apply Crop
        </button>
      </div>
    </div>
  )
}

export default CropTool
